<template>
  <table class="w-100 my-3">
    <tr><td colspan="2"><slot/></td></tr>
    <tr>
      <td colspan="2">
        <mdb-input type="textarea" :rows="4" class="m-0" v-model="question.question"/>
      </td>
    </tr>
    <tr>
      <td colspan="2" class="py-2">
        정답
        <select v-model="question.answer">
          <option v-for="x in 4" :key="x">{{x}}</option>
        </select>
        난이도
        <select v-model="question.difficult">
          <option v-for="(l, x) in ['상', '중', '하']" :key="x">{{l}}</option>
        </select>
        배점
        <input class="w-10 input-underline" v-model="question.assignScore"/>
      </td>
    </tr>
    <tr >
      <td style="width:20px" class="text-right">1)</td>
      <td class="py-2"><input class="w-90 input-underline" v-model="question.q1"/> </td>
    </tr>
    <tr>
      <td style="width:20px" class="text-right">2)</td>
      <td class="py-2"><input class="w-90 input-underline" v-model="question.q2"/> </td>
    </tr>
    <tr>
      <td style="width:20px" class="text-right">3)</td>
      <td class="py-2"><input class="w-90 input-underline" v-model="question.q3"/> </td>
    </tr>
    <tr>
      <td style="width:20px" class="text-right">4)</td>
      <td class="py-2"><input class="w-90 input-underline" v-model="question.q4"/> </td>
    </tr>
  </table>
</template>
<script>
export default {
  name: 'QuestionEdit',
  props: ['question']
}
</script>
<style scoped>
td {
  font-size: 16px;
}
.correct {
  font-size: 30px;
  color: green;
}
.incorrect {
  font-size: 30px;
  color: red;
}

</style>
